export const PricingModels = {
  CPA: 'CPA',
  CPC: 'CPC',
  CPM: 'CPM',
  FLAT_FEE: 'Flat Fee',
};
